// update state
const setContextsExpandCollapse = (payload) => {
    return {
        type: "ACTIONCONTEXTCOLLPASEEXPAND",
        payload
    }
}

export default setContextsExpandCollapse;


// WEBPACK FOOTER //
// ./src/actions/setContextsExpandCollapse.js